export enum Direction {
  Down = 'down',
  Left = 'left',
  Right = 'right',
  Up = 'up',
}

export const defineDirection = (direction: Direction): string => {
  const mapDirections: Record<Direction, string> = {
    left: 'rotate(180deg)',
    right: 'rotate(0)',
    up: 'rotate(270deg)',
    down: 'rotate(90deg)',
  }

  return mapDirections[direction]
}
